import React from 'react';

const ImageShimmer = ({
  className = '',
  aspectRatio = 'auto',
  rounded = 'rounded-lg',
  showIcon = false,
}) => {
  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-r from-[#1A1C20] via-[#25272C] to-[#1A1C20] ${rounded} ${className}`}
      style={{ aspectRatio }}
    >
      {/* Animated shimmer overlay */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite]">
        <div className="h-full w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>

      {/* Optional icon (for product images, etc) */}
      {showIcon && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center animate-pulse">
            <svg
              className="w-6 h-6 text-white/20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        </div>
      )}

      {/* Subtle grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="h-full w-full bg-[linear-gradient(#fff_1px,transparent_1px),linear-gradient(90deg,#fff_1px,transparent_1px)] bg-[size:40px_40px]" />
      </div>
    </div>
  );
};

export default ImageShimmer;
